// src/components/productPage/singleProductPageComponents/ysim/formatters.ts
import { LABELS } from './types';

export const SI_PREFIXES = [
    { value: 1e-12, symbol: 'p' },
    { value: 1e-9, symbol: 'n' },
    { value: 1e-6, symbol: 'µ' },
    { value: 1e-3, symbol: 'm' },
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
] as const;

// ➜ 新增這行：建立 union 型別
export type SIPrefix = (typeof SI_PREFIXES)[number];

export function siScale(value: number | string): string {
    const num = Number(value);
    const abs = Math.abs(num);
    if (abs === 0) return '0';
    // ➜ 用 union 型別標註，避免被推成 only-first-element
    let prefix: SIPrefix = SI_PREFIXES[0];
    for (const p of SI_PREFIXES) {
        if (abs >= p.value) prefix = p;
    }

    for (const p of SI_PREFIXES) if (abs >= p.value) prefix = p;
    const scaled = (num / prefix.value).toFixed(2);
    return `${scaled}${prefix.symbol}`;
}

export function isFreqDomain(selected: string[]) {
    return !(
        selected.includes(LABELS.TCC) ||
        selected.includes(LABELS.VCAC) ||
        selected.includes(LABELS.VBIAS) ||
        selected.includes(LABELS.RIPPLE)
    );
}

export function axisTitleX(selected: string[]) {
    if (selected.includes(LABELS.TCC)) return 'Temperature (°C)';
    if (selected.includes(LABELS.VCAC)) return 'Applied AC Voltage (Vrms)';
    if (selected.includes(LABELS.VBIAS)) return 'Bias Voltage (V)';
    if (selected.includes(LABELS.RIPPLE)) return 'Current (Arms)';
    return 'Frequency (Hz)';
}

// tick formatters
export function makeXTickFormatter(isFreq: boolean) {
    return {
        callback: (value: number | string) => {
            const n = Number(value);
            if (isFreq) {
                const abs = Math.abs(n);
                if (abs === 0) return '0';
                // 只顯示 10 的冪
                if (Math.log10(abs) % 1 !== 0) return '';
                return siScale(n);
            }
            return Number.isFinite(n) ? Number(n).toPrecision(3) : String(value);
        },
    };
}

export function makeYTickFormatter(selected: string[]) {
    const inPercent =
        selected.includes(LABELS.TCC) ||
        selected.includes(LABELS.VCAC) ||
        selected.includes(LABELS.VBIAS);

    return {
        callback: (value: number | string) => {
            if (inPercent) return `${Number(value).toFixed(2)}%`; // ← 固定兩位小數
            const n = Number(value);
            const abs = Math.abs(n);
            if (abs === 0) return '0';
            if (Math.log10(abs) % 1 !== 0) return '';
            return siScale(n);
        },
    };
}
export function tooltipTitleText(selected: string[], x: number) {
    if (isFreqDomain(selected)) return `Frequency: ${siScale(x)}Hz`;
    if (selected.includes(LABELS.TCC)) return `Temperature: ${Number(x).toPrecision(3)}°C`;
    if (selected.includes(LABELS.VCAC))
        return `Applied AC Voltage: ${Number(x).toPrecision(3)} Vrms`;
    if (selected.includes(LABELS.VBIAS)) return `Bias Voltage: ${Number(x).toPrecision(3)} V`;
    if (selected.includes(LABELS.RIPPLE)) return `Current: ${Number(x).toPrecision(3)} Arms`;
    return '';
}
